import {pageInfo, purchOrderPageInfo, add, getPurchOrder, purchOrderSubmit} from '../api';
import {goodsType} from "../../../../../api";

const abnormalPurchOrder = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    plantObj: [],
    purchOrderResp: null,
    purchOrderTotal: 0,
    addObj: null,
    accessoryWork: null,
    purchOrderDetail: null,
    purchOrderSubmit: null,
    goodsTypeObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []);
    },
    PURCH_ORDER_PAGE_INFO(state, data) {
      state.purchOrderResp =  (data.obj || []).map(item => ({...item, btns: [true]}));
      state.purchOrderTotal = data.total;
    },
    ADD(state, data) {
      state.savePurchOrderSwitchObj = data;
    },
    GOODS_TYPE(state, data) {
      state.goodsTypeObj = data;
    },
    ACCESSORY_WORK(state, data) {
      state.accessoryWork = data;
    },
    PURCH_ORDER_DETAIL(state, data) {
      state.purchOrderDetail = data.obj;
    },
    PURCH_ORDER_SUBMIT(state, data) {
      state.purchOrderSubmit = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async purchOrderPageInfo({commit}, obj){
      let result = await purchOrderPageInfo(obj);
      commit('PURCH_ORDER_PAGE_INFO', result);
    },
    async add({commit}, obj){
      let result = await add(obj);
      commit('ADD', result);
    },
    async goodsType({commit}, obj) {
      let resp = await goodsType(obj);
      commit('GOODS_TYPE', resp);
    },
    //液体辅料工作流节点显示
    async getPurchOrder({commit}, obj){
      let resp = await getPurchOrder(obj);
      commit('PURCH_ORDER_DETAIL', resp);
    },
    async purchOrderSubmit({commit}, obj){
      let resp = await purchOrderSubmit(obj);
      commit('PURCH_ORDER_SUBMIT', resp);
    },
  }
}
export default abnormalPurchOrder



// WEBPACK FOOTER //
// ./src/page/bd/order/abnormalPurchOrder/store/abnormalPurchOrder.store.js